import { WhatsappLogo, Phone } from "@phosphor-icons/react";
import { SITE, whatsappLink } from "../lib/data";
import { Reveal } from "./Reveal";

export function ContactCTA() {
  return (
    <section data-testid="contact-cta" className="relative overflow-hidden bg-background grain">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 md:py-40">
        <Reveal>
          <div className="overline text-secondary mb-6">Iniziamo</div>
          <h2 className="serif text-5xl md:text-7xl lg:text-8xl font-light tracking-tighter leading-[0.95] text-primary max-w-4xl">
            Parliamo del tuo immobile.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-lg font-light text-muted-foreground max-w-xl leading-relaxed">
            Nessun modulo, nessuna attesa. Scrivici su WhatsApp o chiamaci: ti rispondiamo con un preventivo su misura per la tua casa vacanza a {SITE.city}.
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <a href={whatsappLink()} target="_blank" rel="noreferrer" data-testid="cta-whatsapp"
               className="group inline-flex items-center justify-center gap-3 rounded-full bg-primary text-primary-foreground px-9 py-5 text-base hover:bg-primary/90 transition-colors active:scale-[0.98]">
              <WhatsappLogo size={22} weight="fill" /> Scrivici su WhatsApp
            </a>
            <a href={`tel:${SITE.phoneHref}`} data-testid="cta-phone"
               className="inline-flex items-center justify-center gap-3 rounded-full border border-primary/25 text-primary px-9 py-5 text-base hover:bg-primary hover:text-primary-foreground transition-colors">
              <Phone size={22} /> {SITE.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
